import type { BaseEntityDTO } from '@hexcrawl/shared-utils';

export type HydratedRoster = Record<string, BaseEntityDTO>;

/** Height in CSS pixels of the bottom action bar. Used to offset the Phaser camera viewport. */
export const COMBAT_ACTION_BAR_HEIGHT = 88;

/** Alpha applied to a Sprite-layer tile when it completely overlaps an entity sprite. */
export const SPRITE_LAYER_OVERLAP_ALPHA = 0.5;

export enum DepthOrder {
  MAP = 0,
  MOVE_HIGHLIGHTS = 10,
  RANGE_HIGHLIGHTS = 11,
  TARGET_HIGHLIGHTS = 15,
  SELECTION_HIGHLIGHTS = 20,
  SPRITES = 50,
  PARTICLES = 100000 // This is very large due to the math used on SPRITES which includes world pos (pixels). To get above the SPRITES depth we need a pretty big number.
}
